import { render, staticRenderFns } from "./mapChsPoint.vue?vue&type=template&id=1c951074"
import script from "./mapChsPoint.vue?vue&type=script&lang=js"
export * from "./mapChsPoint.vue?vue&type=script&lang=js"
import style0 from "./mapChsPoint.vue?vue&type=style&index=0&id=1c951074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports